export const NODE_TYPE_LH = 'LH';
export const NODE_TYPE_LOC = 'LOC';
